export const STEP_TYPES = {
  SCREEN: "screen",
  DIALOG: "dialog",
} as const;

export type StepType = (typeof STEP_TYPES)[keyof typeof STEP_TYPES];
